import type { TranslationKey } from './en.js';

export const he: Partial<Record<TranslationKey, string>> = {
  'app.name': 'Volt',

  'section.chat': 'צ׳אט',
  'section.image': 'תמונות',
  'section.video': 'וידאו',
  'section.video2': 'וידאו 2 (Marketing Studio)',
  'section.character': 'דמות',
  'section.audio': 'מוזיקה ואודיו',
  'section.voice': 'קול',
  'section.design': 'עיצוב',

  'common.loading': 'טוען…',
  'common.error': 'משהו השתבש',
  'common.retry': 'נסה שוב',
  'common.refresh': 'רענן',
  'common.cancel': 'ביטול',
  'common.confirm': 'אישור',
  'common.save': 'שמור',
  'common.close': 'סגור',
  'common.delete': 'מחק',
  'common.create': 'צור',
  'common.apply': 'החל',
  'common.offline': 'לא מקוון — מוצגים נתונים שמורים',
  'common.you': 'אתה',
  'common.assistant': 'עוזר',
  'common.empty': 'עדיין אין כאן כלום',
  'common.back': 'חזרה',

  'auth.loading': 'מתחבר…',
  'auth.openInTelegram': 'פתח אותי בתוך טלגרם',
  'auth.openInTelegramHint':
    'Volt פועל כאפליקציית מיני של טלגרם. הפעל אותו מהצ׳אט עם הבוט כדי להתחבר.',
  'auth.retry': 'נסה שוב',
  'auth.error': 'ההתחברות נכשלה',
  'auth.devHint': 'תצוגת מפתחים — ללא נתוני טלגרם.',

  'topbar.menu': 'פתח תפריט',
  'topbar.settings': 'הגדרות',
  'topbar.balance': 'יתרה',

  'directChat.open': 'פתח צ׳אט פרטי',
  'pager.chat': 'צ׳אט',
  'pager.label': 'מעבר בין מסכים',
  'directChat.title': 'צ׳אט פרטי',
  'directChat.yourId': 'המזהה שלך: {id}',
  'directChat.addPlaceholder': 'מזהה ציבורי או שם משתמש @ בטלגרם',
  'directChat.addFriend': 'הוסף חבר',
  'directChat.addSelf': 'אי אפשר להוסיף את עצמך כחבר.',
  'directChat.friends': 'חברים',
  'directChat.noFriends': 'עדיין אין חברים. הוסף משתמש לפי מזהה ציבורי או שם משתמש @ בטלגרם.',
  'directChat.selectFriend': 'בחר חבר כדי לפתוח את השיחה.',
  'directChat.noMessages': 'אין עדיין הודעות. אמור שלום!',
  'directChat.messagePlaceholder': 'כתיבת הודעה…',
  'directChat.send': 'שלח הודעה',
  'directChat.notFound': 'לא נמצא משתמש עם המזהה או שם המשתמש הזה בטלגרם.',
  'directChat.noPermission': 'אפשר לשלוח הודעות רק לחבר.',
  'directChat.addError': 'בדוק את המזהה או שם המשתמש; ייתכן שהמשתמש כבר נוסף.',
  'directChat.error': 'טעינת הצ׳אט נכשלה. נסה שוב.',
  'directChat.openDrawer': 'פתיחת שיחות',
  'directChat.chats': 'שיחות',
  'directChat.groups': 'קבוצות',
  'directChat.newGroup': 'קבוצה חדשה',
  'directChat.createGroup': 'יצירת קבוצה',
  'directChat.groupName': 'שם הקבוצה',
  'directChat.selectMembers': 'בחירת חברים ({count}/50 כולל אותך)',
  'directChat.memberCount': '{count} חברים',
  'directChat.messages': 'הודעות',
  'directChat.messageActions': 'פעולות הודעה',
  'directChat.reply': 'השבה',
  'directChat.replyingTo': 'תשובה אל {name}',
  'directChat.forward': 'העברה',
  'directChat.forwarded': 'הועברה',
  'directChat.chooseDestination': 'בחירת שיחה להעברה',
  'directChat.deleteForMe': 'מחיקה עבורי',
  'directChat.deleteForEveryone': 'מחיקה לכולם',
  'directChat.deleteForEveryoneConfirm': 'האם למחוק הודעה זו עבור כולם בצ׳אט?',
  'directChat.aiAttribution': 'בינה מלאכותית',
  'directChat.aiToggleEnabled': 'תגובות בינה מלאכותית מופעלות',
  'directChat.aiToggleDisabled': 'תגובות בינה מלאכותית מושבתות',
  'directChat.aiGenerating': 'בינה מלאכותית מגיבה…',
  'directChat.aiGenerationError': 'נכשל ביצירת תגובת בינה מלאכותית: {error}',
  'directChat.aiChooseModel': 'בחר מודל בינה מלאכותית',
  'directChat.aiLongPressHint': 'החזק כדי לבחור מודל',
  'directChat.sent': 'נשלחה',
  'directChat.delivered': 'נמסרה',
  'directChat.read': 'נקראה',

  'sidebar.title': 'צ׳אטים',
  'sidebar.newChat': 'צ׳אט חדש',
  'sidebar.search': 'חיפוש',
  'sidebar.searchPlaceholder': 'חפש בצ׳אטים…',
  'sidebar.projects': 'פרויקטים',
  'sidebar.newProject': 'פרויקט חדש',
  'sidebar.noConversations': 'אין עדיין שיחות',
  'sidebar.archived': 'בארכיון',
  'sidebar.showArchived': 'הצג ארכיון',
  'sidebar.hideArchived': 'הסתר ארכיון',
  'sidebar.pinned': 'מוצמדים',
  'sidebar.today': 'היום',
  'sidebar.yesterday': 'אתמול',
  'sidebar.previous7Days': '7 הימים האחרונים',
  'sidebar.previous30Days': '30 הימים האחרונים',
  'sidebar.older': 'ישן יותר',

  'menu.rename': 'שנה שם',
  'menu.pin': 'הצמד',
  'menu.unpin': 'בטל הצמדה',
  'menu.archive': 'ארכב',
  'menu.unarchive': 'הוצא מארכיון',
  'menu.addToFolder': 'הוסף לתיקייה',
  'menu.moveUp': 'הזז למעלה',
  'menu.moveDown': 'הזז למטה',
  'menu.delete': 'מחק',
  'menu.deleteTitle': 'למחוק את הצ׳אט?',
  'menu.deleteConfirm': 'השיחה וההודעות שלה יימחקו לצמיתות.',

  'project.name': 'שם הפרויקט',
  'project.description': 'תיאור',
  'project.systemPrompt': 'הוראות מותאמות',
  'project.systemPromptHint': 'הוראות אלה נשלחות למודל בכל צ׳אט בפרויקט.',
  'project.create': 'צור פרויקט',
  'project.empty': 'אין עדיין פרויקטים',

  'composer.placeholder': 'הודעה ל‑Volt…',
  'composer.imagePlaceholder': 'תאר את התמונה הרצויה…',
  'composer.videoPlaceholder': 'תאר את הווידאו הרצוי…',
  'composer.characterPlaceholder': 'תאר את הדמות…',
  'composer.audioPlaceholder': 'תאר את המוזיקה או האודיו…',
  'composer.voicePlaceholder': 'טקסט להמרה לדיבור…',

  'character.tabSoulId': 'Soul ID',
  'character.tabCharacter': 'דמות',
  'character.tabSoulCast': 'Soul Cast',
  'character.tabAiInfluencer': 'משפיען AI',
  'character.soulIdTitle': 'אימון Soul ID',
  'character.characterTitle': 'דמויות',
  'character.soulCastTitle': 'Soul Cast',
  'character.aiInfluencerTitle': 'משפיעני AI',
  'character.name': 'שם',
  'character.description': 'תיאור',
  'character.bio': 'ביוגרפיה',
  'character.style': 'סגנון',
  'character.scene': 'סצנה',
  'character.prompt': 'פרומפט',
  'character.referenceImages': 'קישורי תמונות ייחוס, אחד בכל שורה',
  'character.pickSoulId': 'בחר Soul ID',
  'character.pickCharacter': 'בחר דמות',
  'character.noSoulLinked': 'ללא Soul ID מקושר',
  'character.scopeLabel': 'מה ליצור',
  'character.scopeHead': 'ראש',
  'character.scopeFullBody': 'גוף מלא',
  'character.scopeHeadHint': 'תקריבי פנים מזוויות שונות עובדים הכי טוב.',
  'character.scopeFullBodyHint': 'הוסיפו תמונות בגוף מלא כדי ליצור את כל הגוף.',
  'character.scopeBadgeHead': 'ראש',
  'character.scopeBadgeFullBody': 'גוף מלא',
  'character.model3dCreate': 'יצירת מודל תלת־ממדי',
  'character.model3dView': 'צפייה בתלת־ממד',
  'character.model3dBuilding': 'בונים את המודל התלת־ממדי… זה לוקח כמה דקות.',
  'character.model3dFailed': 'לא ניתן ליצור את המודל התלת־ממדי',
  'character.model3dRetry': 'נסו שוב',
  'character.model3dStarted': 'המודל התלת־ממדי נוצר',
  'character.model3dStage': 'מציג מודל תלת־ממדי',
  'character.model3dLoading': 'טוען את המודל…',
  'character.model3dError': 'לא ניתן לפתוח את המודל התלת־ממדי.',
  'character.model3dUnsupported': 'המכשיר שלכם אינו תומך בתלת־ממד (WebGL).',
  'character.model3dHint': 'גררו לסיבוב · צביטה או גלגלת להתקרבות',
  'character.model3dReset': 'איפוס תצוגה',
  'character.model3dAutoRotate': 'סיבוב אוטומטי',
  'character.soulIdPhotoHint': 'העלה 5–20 תמונות ייחוס.',
  'character.soulIdPhotoCount': 'יש לבחור בין 5 ל-20 תמונות.',
  'character.soulIdUploadFailed': 'לא ניתן להעלות את התמונות. נסה שוב.',
  'character.createSoulId': 'צור Soul ID',
  'character.createCharacter': 'צור דמות',
  'character.createAiInfluencer': 'צור משפיען AI',
  'character.generateSoulCast': 'צור Soul Cast',
  'character.generateContent': 'צור תוכן',
  'character.status.training': 'באימון',
  'character.status.ready': 'מוכן',
  'character.status.failed': 'נכשל',
  'composer.send': 'שלח',
  'composer.stop': 'עצור',
  'composer.attach': 'צרף קבצים',
  'composer.attachTitle': 'הוסף קובץ מצורף',
  'composer.attachAllPhotos': 'כל התמונות',
  'composer.attachCamera': 'מצלמה',
  'composer.attachPhotos': 'תמונות',
  'composer.attachFiles': 'קבצים',
  'composer.attachFilesHint': 'תמונות ללא דחיסה',
  'composer.attachToFolder': 'הוסף לתיקייה',
  'composer.voiceInput': 'קלט קולי',
  'composer.listening': 'מקשיב…',
  'composer.thinking': 'חושב…',
  'composer.model': 'מודל',
  'composer.selectModel': 'בחר מודל',
  'composer.unavailable': 'לא זמין',
  'composer.estimate': '≈ {price}',
  'composer.topUpHint': 'טען את היתרה ל‑{amount} כדי להמשיך',
  'composer.generate': 'צור',

  'message.copy': 'העתק',
  'message.copied': 'הועתק',
  'message.share': 'שתף',
  'message.regenerate': 'צור מחדש',
  'message.edit': 'ערוך',
  'message.save': 'שמור ושלח שוב',
  'message.up': 'תשובה טובה',
  'message.down': 'תשובה גרועה',
  'message.usage': '{model} · {input} קלט · {output} פלט · {cost}',
  'message.usageNoModel': '{input} קלט · {output} פלט · {cost}',
  'message.failed': 'היצירה נכשלה',
  'message.reasoningTitle': 'מהלך העיבוד',
  'conversation.pinnedBadge': 'שיחה מוצמדת',

  // TODO: translate share keys
  'share.button': 'Share',
  'share.createLink': 'Create link',
  'share.copyLink': 'Copy link',
  'share.copied': 'Copied!',
  'share.revoke': 'Revoke link',
  'share.revokeConfirm':
    'Are you sure you want to revoke this link? Anyone with the link will no longer be able to access it.',
  'share.title': 'Share conversation',
  'share.sharedBy': 'Shared snapshot',
  'share.notFound': 'This link has expired or been revoked.',
  'share.openApp': 'Open Volt',
  'share.loading': 'Loading…',
  'share.sendToChat': 'שלח לצ׳אט',
  'share.noDestinations': 'אין צ׳אטים או קבוצות זמינים',
  'share.sentSuccess': 'נשלח בהצלחה!',
  'share.sending': 'שולח…',
  'share.loadingDestinations': 'טוען צ׳אטים…',
  'artifact.preview': 'תצוגה מקדימה',
  'artifact.code': 'קוד',
  'artifact.open': 'פתח פריט',
  'artifact.export': 'ייצא',
  'artifact.download': 'הורד',
  'artifact.copy': 'העתק',
  'artifact.edit': 'ערוך',
  'artifact.close': 'סגור',
  'artifact.fullscreen': 'מסך מלא',

  'job.status': 'סטטוס',
  'job.pending': 'בתור',
  'job.processing': 'מעבד…',
  'job.done': 'הושלם',
  'job.failed': 'נכשל',
  'job.cancelled': 'בוטל',
  'job.result': 'תוצאה',
  'job.empty': 'אין עדיין יצירות',
  'job.actions': 'פעולות',
  'job.favoriteAdd': 'הוסף למועדפים',
  'job.favoriteRemove': 'הסר מהמועדפים',
  'job.favorited': 'מועדף',
  'job.regenerate': 'צור מחדש',
  'job.viewPrompt': 'הצג פרומפט',
  'job.promptTitle': 'פרומפט',
  'job.download': 'הורדה',
  'job.deleteTitle': 'למחוק את היצירה?',
  'job.deleteConfirm': 'היצירה תימחק לצמיתות.',

  'design.subtitle': 'פתח כלי עיצוב בחלון חדש',
  'design.open': 'פתח',

  'settings.title': 'הגדרות',
  'settings.profile': 'פרופיל',
  'settings.appearance': 'מראה',
  'settings.theme': 'ערכת נושא',
  'settings.themeLight': 'בהיר',
  'settings.themeDark': 'כהה',
  'settings.themeSystem': 'מערכת',
  'settings.language': 'שפה',
  'settings.balance': 'יתרה',
  'settings.topup': 'טעינה',
  'settings.topupAmount': 'סכום, ₽',
  'settings.topupSubmit': 'טען יתרה',
  'settings.transactions': 'היסטוריית עסקאות',
  'settings.noTransactions': 'אין עדיין עסקאות',
  'settings.loadMore': 'טען עוד',
  'settings.notifications': 'התראות',
  'settings.notificationsHint': 'הודע לי כשיצירות מסתיימות',
  'settings.data': 'הנתונים שלך',
  'settings.exportData': 'ייצא את הנתונים שלי',
  'settings.deleteAccount': 'מחק חשבון',
  'settings.deleteAccountTitle': 'למחוק את החשבון שלך?',
  'settings.deleteAccountConfirm':
    'פעולה זו מוחקת לצמיתות את החשבון, השיחות והיתרה שלך. לא ניתן לבטל.',
  'settings.username': 'שם משתמש',
  'settings.name': 'שם',

  'admin.title': 'ניהול',
  'admin.stats': 'סטטיסטיקה',
  'admin.users': 'משתמשים',
  'admin.settings': 'הגדרות פלטפורמה',
  'admin.markup': 'תוספת, %',
  'admin.usdRub': 'שער USD → RUB',
  'admin.minBalance': 'יתרה מזערית, ₽',
  'admin.contextLimit': 'הודעות הקשר',
  'admin.models': 'תמחור מודלים',
  'admin.price': 'מחיר',
  'admin.revenue': 'הכנסה',
  'admin.cost': 'עלות ספק',
  'admin.margin': 'רווח',
  'admin.activeUsers': 'פעילים (24 שעות)',
  'admin.failedJobs': 'משימות שנכשלו',
  'admin.ban': 'חסום',
  'admin.unban': 'בטל חסימה',
  'admin.adjustBalance': 'התאם יתרה',
  'admin.reason': 'סיבה',
  'admin.amount': 'סכום, ₽',
  'admin.errorHistory': 'היסטוריית שגיאות',
  'admin.errorsEmpty': 'אין שגיאות רשומות עדיין.',

  'error.UNAUTHORIZED': 'ההתחברות פגה. פתח מחדש את האפליקציה.',
  'error.FORBIDDEN': 'אין לך גישה לזה.',
  'error.USER_BANNED': 'החשבון שלך הושעה.',
  'error.NOT_FOUND': 'לא נמצא.',
  'error.RATE_LIMITED': 'יותר מדי בקשות. האט מעט.',
  'error.DAILY_LIMIT_EXCEEDED': 'הגעת למגבלה היומית. נסה מחר.',
  'error.INSUFFICIENT_BALANCE': 'אין מספיק יתרה לבקשה זו.',
  'error.BELOW_MIN_BALANCE': 'היתרה שלך מתחת למינימום הנדרש.',
  'error.MODEL_UNAVAILABLE': 'מודל זה אינו זמין כרגע.',
  'error.MODEL_NOT_SUPPORTED': 'מודל זה אינו נתמך כאן.',
  'error.PROVIDER_ERROR': 'הספק החזיר שגיאה.',
  'error.PROVIDER_TIMEOUT': 'תם הזמן הקצוב לספק.',
  'error.CONTEXT_TOO_LARGE': 'השיחה ארוכה מדי עבור המודל.',
  'error.PAYMENT_INVALID': 'לא ניתן היה לעבד את התשלום.',
  'error.INTERNAL': 'שגיאת שרת. נסה שוב.',
  'error.network': 'שגיאת רשת. בדוק את החיבור.',
  'error.streamInterrupted': 'החיבור נותק. התגובה שוחזרה מהשרת.',
  'error.generic': 'משהו השתבש.',
};
